module.exports = __webpack_public_path__ + "media/images/pic/newsletter-21d4865cb174b6982356edfa6dff9c66.svg";